module.exports = __webpack_public_path__ + "static/media/casa.543d5949.svg";